import React from 'react';

export default function Marquee({ children, speed = 40 }) {
  const durationStyle = { animationDuration: `${speed}s` };
  return (
    <div className="marquee-wrap">
      <div className="marquee-track" style={durationStyle}>
        <div className="marquee-content">{children}</div>
        <div className="marquee-content" aria-hidden="true">{children}</div>
      </div>
    </div>
  );
}
